import React from 'jsx-dom';
export const ResetIcon = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-2 -2 12 12" },
    React.createElement("path", { d: "M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4c1.1 0 2.12-.43 2.84-1.16l-.72-.72c-.54.54-1.29.88-2.13.88-1.66 0-3-1.34-3-3s1.34-3 3-3c.83 0 1.55.36 2.09.91L4.99 3h3V0L6.8 1.19C6.08.47 5.09 0 3.99 0z" })));
